import React from 'react';
import { ModalForm, AfterSubmitProps, FormFieldsData } from 'framework/form';
import { useDocumentStorageContext } from 'framework/documentStorage';
import ViewProcessAssetContent from './ViewProcessAssetContent';
import { ProcessAssetsType } from 'domain/gpo/processAssets/types';
import { useShowContext } from 'framework/show';

const ViewProcessAssetAction = ({
  modalOpen,
  closeModal,
  afterSubmit,
}: {
  modalOpen: boolean;
  closeModal: () => void;
  afterSubmit: AfterSubmitProps<(response: FormFieldsData) => void>;
}) => {
  const { data } = useShowContext<ProcessAssetsType>();
  const { editDocument, getValidationSchema } = useDocumentStorageContext();

  const documentData = data.getData();

  const initialData = {
    ...documentData.metadata,
    paths: [documentData.path],
  };

  return (
    <ModalForm
      getValidationSchemaFunc={getValidationSchema}
      modalOpen={modalOpen}
      closeModal={closeModal}
      handleDirty
      submitFormFunc={editDocument}
      afterSubmit={{
        ...afterSubmit,
      }}
      initialData={initialData}
      isHideDefaultButtons
    >
      <ViewProcessAssetContent />
    </ModalForm>
  );
};

export default ViewProcessAssetAction;
